/**
 * Runtime configuration for the Personal Data Sheet wizard.
 *
 * All client-form frontends talk to the same unified service, so the
 * production URL is injected at build time from SSM by the deploy workflow.
 */
const config = {
  apiUrl: process.env.REACT_APP_PDS_API_URL || 'http://localhost:8019',
};

export default config;
